import config from "../../config/app";

export const getNextAvailableNumber = (code: string): Promise<number> =>
  new Promise((resolve, reject) => {
    fetch(config.numberGenerator.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ code })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(data => (data && data.value) || 0)
      .then(resolve)
      .catch(reject);
  });
